import { toast } from 'react-toastify';
import uuidv4 from 'uuid/v4';
import { adminBlockStatusUpdate } from '../Actions/AdminBlockAction';
import { updateBlockedContactAction, updateContactWhoBlockedMeAction } from '../Actions/BlockAction';
import { webSettingLocalAction } from '../Actions/BrowserAction';
import {
    CallConnectionState,
    callConversion,
    callDurationTimestamp,
    callIntermediateScreen,
    isMuteAudioAction,
    resetCallIntermediateScreen,
    resetConferencePopup,
    resetData,
    selectLargeVideoUser,
    setCallQuality,
    setPoorConnectionIcon,
    setPoorConnectionPopUp,
    showConfrence,
} from '../Actions/CallAction';
import { deleteAllCallLog, fetchingCallLog } from '../Actions/CallLogAction';
import {
    ChatMessageHistoryDataAction,
    ClearChatHistoryAction,
    ClearChatHistoryActionCommon,
    DeleteChatHistoryAction,
    RemoveAllStarredMessagesHistory,
    UpdateFavouriteStatus,
} from '../Actions/ChatHistory';
import { WebChatConnectionState } from '../Actions/ConnectionState';
import {
    GroupDataUpdateAction,
    GroupsDataAction,
    GroupsMemberListAction,
    currentCallGroupMembers,
} from '../Actions/GroupsAction';
import { MediaDownloadDataAction, MediaUploadDataAction } from '../Actions/Media';
import { MessageAction, messageForwardReset, messageInfoAction } from '../Actions/MessageActions';
import { PresenceDataAction } from '../Actions/PresenceAction';
import { updateGroupName } from '../Actions/SingleChatMessageActions';
import {
    ActiveChatResetAction,
    RecentChatAction,
    RecentChatUpdateAction,
    clearLastMessageinRecentChat,
    deleteActiveChatAction,
    updateArchiveStatusRecentChat,
    updateMsgByLastMsgId,
} from '../Actions/RecentChatActions';
import { RosterDataAction, RosterPermissionAction } from '../Actions/RosterActions';
import {
    RemoveAllStarredMessages,
    RemoveStaredMessagesClearChat,
    RemoveStaredMessagesDeleteChat,
    UpdateStarredMessages,
} from '../Actions/StarredAction';
import { VCardContactDataAction, VCardDataAction } from '../Actions/VCardActions';
import { fetchPinnedMessages } from '../slice/pinnedMessagesSlice';
import { receiveKeepPush } from '../features/chatDetail/keepMessage/keepActions';
import { applyPollEvent, receivePollActivities } from '../features/poll/pollEvents';
import { receiveLiveLocationEvent } from '../features/location/liveLocationActions';
import { handleMessageError, MESSAGE_ERROR } from '../features/outbox/handleMessageError';
import { VCARD_CONTACT_DATA_ACTION, VCARD_DATA } from '../Actions/Constants';
import {
    deleteAllIndexedDb,
    getUserIdFromJid,
    logout,
    normalizeXmlText,
    sendNotification,
    setLocalWebsettings,
    stopRecorder,
    updateMuteSettings,
    updateMuteStatus,
} from '../Helpers/Utility';
import { Store } from '../store';
import { showModal, hideModal } from '../Actions/PopUp';
import {
    resetPinAndLargeVideoUser,
    dispatchDisconnected,
    updateCallTypeAfterCallSwitch,
    startCallingTimer,
    startMissedCallNotificationTimer,
    clearMissedCallNotificationTimer,
    handleCallParticipantToast,
    disconnectCallConnection,
    clearOldCallingTimer,
} from '../Helpers/Call/Call';
import {
    CALL_CONVERSION_STATUS_CANCEL,
    CALL_CONVERSION_STATUS_REQ_WAITING,
    CALL_BUSY_STATUS_MESSAGE,
    CALL_ENGAGED_STATUS_MESSAGE,
    CALL_STATUS_CONNECTED,
    DISCONNECTED_SCREEN_DURATION,
    CALL_TYPE_AUDIO,
    CALL_TYPE_VIDEO,
    CALL_STATUS_RECONNECT,
    CALL_STATUS_HOLD,
    CALL_STATUS_ENDED,
    CALL_STATUS_ATTENDED,
} from '../Helpers/Call/Constant';
import browserNotify from '../Helpers/Browser/BrowserNotify';
import {
    getActiveConversationChatId,
    getArchivedChats,
    handleTempArchivedChats,
    isActiveConversationUserOrGroup,
    isGroupChat,
    isSameSession,
} from '../Helpers/Chat/ChatHelper';
import { syncMutedChats } from '../Helpers/Chat/muteState';
import {
    CARBON_LOGOUT,
    CHAT_TYPE_GROUP,
    CHAT_TYPE_SINGLE,
    CONNECTION_STATE_CONNECTING,
    DELETE_CALL_LOG,
    GROUP_CHAT_PROFILE_UPDATED_NOTIFY,
    GROUP_DISAPPEAR_UPDATED,
    GROUP_PROFILE_INFO_UPDATED,
    GROUP_USER_ADDED,
    GROUP_USER_LEFT,
    GROUP_USER_MADE_ADMIN,
    GROUP_USER_REMOVED,
    LOGOUT,
    MSG_CLEAR_CHAT,
    MSG_CLEAR_CHAT_CARBON,
    MSG_DELETE_CHAT,
    MSG_DELETE_CHAT_CARBON,
    STORY_LIKE,
    STORY_POSTED,
    STORY_RECEIVED,
    STORY_VIEWER_INFO,
} from '../Helpers/Chat/Constant';
import {
    getGroupData,
    isGroupDisappearNotice,
    setGroupParticipants,
    setGroupParticipantsByGroupId,
} from '../Helpers/Chat/Group';
import {
    formatUserIdToJid,
    getDataFromRoster,
    getLocalUserDetails,
    getLocalUserId,
    getUserDetails,
    isLocalUser,
    isSingleChatJID,
} from '../Helpers/Chat/User';
import { deletedUserInfo, setUserInfoArr } from '../slice';
import { handleIncomingChannelEvents } from '../channels/utils';
import { PrivacySettingsAction } from '../Actions/PrivacySettingsAction';
import messagesIdb from '../Helpers/MessagesIdb';
import recentChatIdb from '../Helpers/RecentChatIdb';
import { UnreadCountDelete } from '../Actions/UnreadCount';
import {
    setMyStories,
    setStories,
    mergeStoryViewers,
    removeStoryById,
    updateStoryViewerLike,
} from '../slice/storiesSlice';
import { scheduleMessageExpiry } from '../Helpers/Chat/DisappearScheduler';
import logger from '../Helpers/logger';
import { updateLastSyncTime } from './WebChat/Authentication/synchronisation/config';
import { handleGroupProfileUpdate } from './WebChat/Authentication/synchronisation/GroupSync';
import { getConnectionStatus, setConnectionStatus } from './WebChat/Common/FileUploadValidation';
import {
    deleteItemFromLocalStorage,
    encryptAndStoreInLocalStorage,
    encryptAndStoreInSessionStorage,
    getFromLocalStorageAndDecrypt,
    getFromSessionStorageAndDecrypt,
} from './WebChat/WebChatEncryptDecrypt';
import { login, reconnect, serverReconnect } from './WebChat/Authentication/Reconnect';
import SDK from './SDK';
import { REACT_APP_CONTACT_SYNC, REACT_APP_XMPP_SOCKET_HOST } from './processENV';
import callLogs from './WebCall/CallLogs/callLog';

// Tracks chat IDs where a disappear update is in-flight so duplicate banners
// from messageListener (msgDisappear / groupProfileUpdated paths) are suppressed.
const pendingDisappearGroupUpdates = new Set();

// Called by ContactInfo before SDK.setChatMessageDisappear so the subsequent
// msgDisappear callback (which fires on the originating device) skips its own
// banner dispatch and avoids creating a duplicate.
export const markSingleDisappearHandled = chatId => {
    if (!chatId) return;
    pendingDisappearGroupUpdates.add(chatId);
    setTimeout(() => pendingDisappearGroupUpdates.delete(chatId), 5000);
};

let localStream = null,
    localVideoMuted = false,
    localAudioMuted = false,
    onCall = false,
    localUserOnCall = false;
let remoteVideoMuted = [],
    remoteStream = [],
    remoteAudioMuted = [];

export const resetCallData = () => {
    const callIntermediateScreen = Store.getState().callIntermediateScreen;
    if (callIntermediateScreen?.data?.show) return;
    onCall = false;
    localUserOnCall = false;
    remoteStream = [];
    localStream = null;
    remoteVideoMuted = [];
    remoteAudioMuted = [];
    localVideoMuted = false;
    localAudioMuted = false;
    if (getFromLocalStorageAndDecrypt('isNewCallExist') === true) {
        deleteItemFromLocalStorage('isNewCallExist');
    } else {
        Store.dispatch(resetCallIntermediateScreen());
    }
    resetData();
    clearOldCallingTimer();
    Store.dispatch(isMuteAudioAction(false));
    Store.dispatch(setCallQuality('GOOD'));
    Store.dispatch(setPoorConnectionIcon(false));
    Store.dispatch(setPoorConnectionPopUp(false));
};

export const muteLocalVideo = isMuted => {
    localVideoMuted = isMuted;
    let vcardData = getLocalUserDetails();
    let currentUser = vcardData?.fromUser;
    currentUser = currentUser + '@' + REACT_APP_XMPP_SOCKET_HOST;
    remoteVideoMuted[currentUser] = isMuted;
};

export const muteLocalAudio = isMuted => {
    localAudioMuted = isMuted;
    let vcardData = getLocalUserDetails();
    let currentUser = vcardData?.fromUser;
    currentUser = currentUser + '@' + REACT_APP_XMPP_SOCKET_HOST;
    remoteAudioMuted[currentUser] = isMuted;
};

const updatingUserStatusInRemoteStream = usersStatus => {
    usersStatus.map(user => {
        const index = remoteStream.findIndex(item => item.fromJid === user.userJid);
        if (index > -1) {
            const status = user.status ? user.status.toLowerCase() : '';
            remoteStream[index] = {
                ...remoteStream[index],
                platform: user.platform || '',
                status:
                    remoteStream[index].status === CALL_STATUS_RECONNECT && status === CALL_STATUS_ATTENDED
                        ? remoteStream[index].status
                        : status,
            };
            remoteVideoMuted[user.userJid] = user.videoMuted;
            remoteAudioMuted[user.userJid] = user.audioMuted;
        } else {
            let streamObject = {
                id: uuidv4(),
                fromJid: user.userJid,
                platform: user.platform || '',
                status: user.status || CONNECTION_STATE_CONNECTING,
            };
            remoteStream.push(streamObject);
            remoteVideoMuted[user.userJid] = user.videoMuted;
            remoteAudioMuted[user.userJid] = user.audioMuted;
        }
    });
};

const removingRemoteStream = res => {
    remoteStream.forEach((item, key) => {
        if (item.fromJid === res.userJid) {
            remoteStream.splice(key, 1);
        }
    });
};

export const removeRemoteStream = userJid => {
    remoteStream.forEach((item, key) => {
        if (item.fromJid === userJid) {
            remoteStream.splice(key, 1);
        }
    });
};

export const getRemoteStream = () => remoteStream;

const updateStoreRemoteStream = () => {
    const { getState } = Store;
    const { data = {} } = getState().showConfrenceData;
    Store.dispatch(
        showConfrence({
            ...data,
            remoteStream,
        }),
    );
};

const ringing = res => {
    if (!onCall) {
        const callConnectionData = JSON.parse(getFromLocalStorageAndDecrypt('call_connection_status'));
        if (callConnectionData.callType === 'audio') {
            localVideoMuted = true;
        }
        Store.dispatch(
            showConfrence({
                callStatusText: 'Ringing',
                showStreamingComponent: false,
                localStream,
                remoteStream,
                localVideoMuted,
                localAudioMuted,
                showComponent: true,
            }),
        );
    } else {
        const { getState } = Store;
        const showConfrenceData = getState().showConfrenceData;
        const { data } = showConfrenceData;
        const index = remoteStream.findIndex(item => item.fromJid === res.userJid);
        if (index > -1) {
            remoteStream[index] = {
                ...remoteStream[index],
                status: res.status,
            };
            Store.dispatch(
                showConfrence({
                    ...(data || {}),
                    remoteStream: remoteStream,
                }),
            );
        }
    }
};

const connecting = res => {
    updatingUserStatusInRemoteStream(res.usersStatus);
    let roomId = getFromLocalStorageAndDecrypt('roomName');
    encryptAndStoreInLocalStorage('callingComponent', false);
    const showConfrenceData = Store.getState().showConfrenceData;
    const { data } = showConfrenceData;
    // If 'data.showStreamingComponent' property value is TRUE means, already call is connected &
    // Streaming data has been shared between users. That's why we check condition here,
    // If 'data.showStreamingComponent' is FALSE, then set the 'CONNECTING' state to display.
    if (data && !data.showStreamingComponent) {
        remoteStream = [];
        encryptAndStoreInLocalStorage('connecting', true);
        Store.dispatch(
            showConfrence({
                showComponent: true,
                showStreamingComponent: false,
                showCallingComponent: false,
            }),
        );
        callLogs.update(roomId, {
            sessionStatus: res.sessionStatus,
            startTime: callLogs.initTime(),
        });
    }
};

const updateCallConnectionStatus = usersStatus => {
    const callConnectionData = JSON.parse(getFromLocalStorageAndDecrypt('call_connection_status'));
    let usersLen;
    if (usersStatus.length) {
        let currentUsers = usersStatus.filter(el => el.status.toLowerCase() !== CALL_STATUS_ENDED);
        usersLen = currentUsers.length;
    }
    let callDetailsObj = {
        ...callConnectionData,
        callMode:
            (callConnectionData?.groupId && callConnectionData.groupId !== null && callConnectionData.groupId !== '') ||
            usersLen > 2
                ? 'onetomany'
                : 'onetoone',
    };
    encryptAndStoreInLocalStorage('call_connection_status', JSON.stringify(callDetailsObj));
};

const connected = res => {
    const userIndex = remoteStream.findIndex(item => item.fromJid === res.userJid);
    const behaviorResponse = SDK.getCallBehaviour();
    let behavior = 'call';
    if (behaviorResponse.statusCode === 200) {
        behavior = behaviorResponse.data;
    }
    if (behavior === 'meet' || userIndex > -1) {
        let usersStatus = res.usersStatus;
        updatingUserStatusInRemoteStream(usersStatus);
        updateCallConnectionStatus(usersStatus);
        const { getState, dispatch } = Store;
        const showConfrenceData = getState().showConfrenceData;
        const { data } = showConfrenceData;
        let showComponent = !!data.showComponent;
        let showStreamingComponent = !!data.showStreamingComponent;
        if (!showStreamingComponent) {
            deleteItemFromLocalStorage('connecting');
            showComponent = false;
            showStreamingComponent = true;
        }
        dispatch(
            showConfrence({
                ...(data || {}),
                showComponent,
                showStreamingComponent,
                remoteStream,
                localStream,
                status: res.callStatus,
                localVideoMuted: localVideoMuted,
                localAudioMuted: localAudioMuted,
                remoteVideoMuted: remoteVideoMuted,
                remoteAudioMuted: remoteAudioMuted,
                callStatusText: CALL_STATUS_CONNECTED,
            }),
        );
    }
};

const disconnected = res => {
    let roomId = getFromLocalStorageAndDecrypt('roomName');
    let vcardData = getLocalUserDetails();
    let currentUser = vcardData?.fromUser;
    currentUser = currentUser + '@' + REACT_APP_XMPP_SOCKET_HOST;
    updatingUserStatusInRemoteStream(res.usersStatus);
    let disconnectedUser = res.userJid;
    disconnectedUser = disconnectedUser.includes('@') ? disconnectedUser.split('@')[0] : disconnectedUser;
    if (remoteStream.length < 1 || disconnectedUser === currentUser) {
        deleteItemFromLocalStorage('roomName');
        deleteItemFromLocalStorage('callType');
        deleteItemFromLocalStorage('call_connection_status');
        callLogs.update(roomId, {
            endTime: callLogs.initTime(),
            sessionStatus: res.sessionStatus,
        });
        Store.dispatch(
            showConfrence({
                showComponent: false,
                showStreamingComponent: false,
                showCalleComponent: false,
            }),
        );
        resetPinAndLargeVideoUser();
        Store.dispatch(hideModal());
        resetCallData();
    } else {
        Store.dispatch(
            showConfrence({
                showComponent: false,
                showStreamingComponent: true,
                showCallingComponent: false,
                localStream: localStream,
                remoteStream: remoteStream,
                fromJid: '',
                status: 'REMOTESTREAM',
                localVideoMuted: localVideoMuted,
                localAudioMuted: localAudioMuted,
                remoteVideoMuted: remoteVideoMuted,
                remoteAudioMuted: remoteAudioMuted,
            }),
        );
        resetPinAndLargeVideoUser(res.fromJid);
        removingRemoteStream(res);
    }
    Store.dispatch(fetchingCallLog(true));
    callLogs.getCallLogsFromServer(1);
};

export const localstoreCommon = () => {
    encryptAndStoreInLocalStorage('callingComponent', false);
    deleteItemFromLocalStorage('roomName');
    deleteItemFromLocalStorage('callType');
    deleteItemFromLocalStorage('call_connection_status');
    deleteItemFromLocalStorage('inviteStatus');
    encryptAndStoreInLocalStorage('hideCallScreen', false);
};

export const dispatchCommon = () => {
    Store.dispatch(
        showConfrence({
            callStatusText: null,
            showComponent: false,
            showStreamingComponent: false,
            stopSound: true,
            showCalleComponent: false,
        }),
    );
    Store.dispatch(callConversion());
    Store.dispatch(hideModal());
    Store.dispatch(callDurationTimestamp());
    Store.dispatch(resetConferencePopup());
    resetCallData();
};

const handleEngagedOrBusyStatus = res => {
    let roomId = getFromLocalStorageAndDecrypt('roomName');
    updatingUserStatusInRemoteStream(res.usersStatus);
    if (res.sessionStatus === 'closed') {
        callLogs.update(roomId, {
            endTime: callLogs.initTime(),
            sessionStatus: res.sessionStatus,
        });
        const callStatusMsg = res.status === 'engaged' ? CALL_ENGAGED_STATUS_MESSAGE : CALL_BUSY_STATUS_MESSAGE;
        dispatchDisconnected(callStatusMsg);
        localCallDataClearAndDiscardUi();
    } else {
        if (remoteStream && Array.isArray(remoteStream) && remoteStream.length < 1) {
            return;
        }
        const { getState } = Store;
        const showConfrenceData = getState().showConfrenceData;
        const { data } = showConfrenceData;
        if (!onCall) {
            let callConnectionData = JSON.parse(getFromLocalStorageAndDecrypt('call_connection_status'));
            let userList = callConnectionData.userList.split(',');
            let updatedUserList = [];
            userList.forEach(user => {
                if (user !== res.userJid) {
                    updatedUserList.push(user);
                }
            });
            callConnectionData.userList = updatedUserList.join(',');
            if (callConnectionData.callMode === 'onetomany' && !callConnectionData.groupId) {
                if (updatedUserList.length > 1) {
                    callConnectionData.callMode = 'onetomany';
                } else {
                    callConnectionData.callMode = 'onetoone';
                    callConnectionData.to = updatedUserList[0];
                }
            }
            encryptAndStoreInLocalStorage('call_connection_status', JSON.stringify(callConnectionData));
            Store.dispatch(CallConnectionState(callConnectionData));
        }
        let userDetails = getUserDetails(res.userJid);
        let toastMessage =
            res.status === 'engaged'
                ? `${userDetails.displayName} is on another call`
                : `${userDetails.displayName} is busy`;
        toast.error(toastMessage);
        removingRemoteStream(res);
        if (data.showStreamingComponent) {
            resetPinAndLargeVideoUser(res.userJid);
        }
        Store.dispatch(
            showConfrence({
                ...(data || {}),
                remoteStream: remoteStream,
                remoteVideoMuted,
                remoteAudioMuted,
            }),
        );
    }
};

const ended = res => {
    deleteItemFromLocalStorage('inviteStatus');
    let roomId = getFromLocalStorageAndDecrypt('roomName');
    if (res.sessionStatus === 'closed') {
        let callConnectionData = null;
        if (remoteStream && !onCall && !res.carbonAttended) {
            // Call ended before attend
            callConnectionData = JSON.parse(getFromLocalStorageAndDecrypt('call_connection_status'));
        }
        callLogs.update(roomId, {
            endTime: callLogs.initTime(),
            sessionStatus: res.sessionStatus,
        });
        dispatchDisconnected();
        if (callConnectionData) {
            clearMissedCallNotificationTimer();
        }
        localstoreCommon();
        Store.dispatch(
            showConfrence({
                showCalleComponent: false,
                showStreamingComponent: false,
                showComponent: false,
                callStatusText: 'ended',
                stopSound: true,
            }),
        );
        Store.dispatch(callConversion());
        Store.dispatch(hideModal());
        Store.dispatch(CallConnectionState(res));
        if (callConnectionData) {
            const callDetailObj = callConnectionData
                ? {
                      ...callConnectionData,
                  }
                : {};
            callDetailObj['status'] = 'ended';
            browserNotify.sendCallNotification(callDetailObj);
        }
        resetCallData();
    } else {
        if (!onCall || (remoteStream && Array.isArray(remoteStream) && remoteStream.length < 1)) {
            return;
        }
        removingRemoteStream(res);
        resetPinAndLargeVideoUser(res.userJid);
        updateCallConnectionStatus(res.usersStatus);
        const { getState } = Store;
        const showConfrenceData = getState().showConfrenceData;
        const { data } = showConfrenceData;
        Store.dispatch(
            showConfrence({
                ...(data || {}),
                remoteStream: remoteStream,
                remoteVideoMuted,
                remoteAudioMuted,
            }),
        );
    }
    Store.dispatch(fetchingCallLog(true));
    callLogs.getCallLogsFromServer(1);
};

const reconnecting = res => {
    updatingUserStatusInRemoteStream(res.usersStatus);
    const { getState } = Store;
    const showConfrenceData = getState().showConfrenceData;
    const { data } = showConfrenceData;
    let vcardData = getLocalUserDetails();
    let currentUser = vcardData?.fromUser + '@' + REACT_APP_XMPP_SOCKET_HOST;
    if (currentUser === res.userJid) {
        Store.dispatch(
            showConfrence({
                showCallingComponent: false,
                ...(data || {}),
                localStream: localStream,
                remoteStream: remoteStream,
                fromJid: res.userJid,
                status: 'REMOTESTREAM',
                localVideoMuted: localVideoMuted,
                localAudioMuted: localAudioMuted,
                remoteVideoMuted: remoteVideoMuted,
                remoteAudioMuted: remoteAudioMuted,
                callStatusText: CALL_STATUS_RECONNECT,
            }),
        );
    } else {
        Store.dispatch(
            showConfrence({
                showCallingComponent: false,
                ...(data || {}),
                localStream: localStream,
                remoteStream: remoteStream,
                fromJid: res.userJid,
                status: 'REMOTESTREAM',
                localVideoMuted: localVideoMuted,
                localAudioMuted: localAudioMuted,
                remoteVideoMuted: remoteVideoMuted,
                remoteAudioMuted: remoteAudioMuted,
            }),
        );
    }
};

const speaking = res => {
    if (!res.userJid) return;
    if (!res.localUser) {
        Store.dispatch(selectLargeVideoUser(res.userJid, res.volumeLevel));
    }
};

const userStatus = res => {
    updatingUserStatusInRemoteStream(res.usersStatus);
};

const hold = res => {
    updatingUserStatusInRemoteStream(res.usersStatus);
    const { getState } = Store;
    const showConfrenceData = getState().showConfrenceData;
    const { data } = showConfrenceData;
    Store.dispatch(
        showConfrence({
            showCallingComponent: false,
            ...(data || {}),
            localStream: localStream,
            remoteStream: remoteStream,
            fromJid: res.userJid,
            status: 'REMOTESTREAM',
            localVideoMuted: localVideoMuted,
            localAudioMuted: localAudioMuted,
            remoteVideoMuted: remoteVideoMuted,
            remoteAudioMuted: remoteAudioMuted,
            callStatusText: CALL_STATUS_HOLD,
        }),
    );
};

const subscribed = _res => {
    const { getState, dispatch } = Store;
    const showConfrenceData = getState().showConfrenceData;
    const { data } = showConfrenceData;
    dispatch(
        showConfrence({
            ...(data || {}),
            localVideoMuted: data.mediaError ? localVideoMuted : false,
            localStream: localStream,
            remoteStream,
            localAudioMuted: localAudioMuted,
            status: 'SUBSCRIBED',
        }),
    );
};

const callStatus = res => {
    if (res.status === 'ringing') {
        ringing(res);
    } else if (res.status === 'connecting') {
        connecting(res);
    } else if (res.status === 'connected') {
        connected(res);
    } else if (res.status === 'busy') {
        handleEngagedOrBusyStatus(res);
    } else if (res.status === 'disconnected') {
        disconnected(res);
    } else if (res.status === 'engaged') {
        handleEngagedOrBusyStatus(res);
    } else if (res.status === 'ended') {
        ended(res);
    } else if (res.status === 'reconnecting') {
        reconnecting(res);
    } else if (res.status === 'userstatus') {
        userStatus(res);
    } else if (res.status === 'hold') {
        hold(res);
    }
};

export const buildStoryGroup = ({ userId, stories = [], includeMeta = false }) => {
    let unseenCount = 0;
    let lastUpdatedAt = 0;

    for (const story of stories) {
        const createdAt = Number(story.createdAt || 0);

        if (!story.seen) {
            unseenCount++;
        }

        if (createdAt > lastUpdatedAt) {
            lastUpdatedAt = createdAt;
        }
    }

    const sortedStories = stories.toSorted((a, b) => Number(a.createdAt) - Number(b.createdAt));

    return {
        userId,

        lastUpdatedAt,

        ...(includeMeta && {
            totalCount: sortedStories.length,

            unseenCount,

            hasUnseen: unseenCount > 0,
        }),

        stories: sortedStories,
    };
};

const groupStoryByUser = (existingStories = [], newStory = {}, includeMeta = false) => {
    try {
        if (!newStory || typeof newStory !== 'object' || !newStory.userId || !newStory.storyId || !newStory.createdAt) {
            logger.warn('Invalid story object:', newStory);
            return existingStories;
        }

        // clone state safely
        const updatedStories = [...existingStories];

        // Find existing user
        const userIndex = updatedStories.findIndex(user => user?.userId === newStory.userId);

        // EXISTING USER
        if (userIndex !== -1) {
            const existingUser = updatedStories[userIndex];

            // fallback safety
            const existingUserStories = Array.isArray(existingUser.stories) ? existingUser.stories : [];

            // prevent duplicate story
            const alreadyExists = existingUserStories.some(story => story.storyId === newStory.storyId);

            // no update needed
            if (alreadyExists) {
                return existingStories;
            }

            // add new story
            const mergedStories = [...existingUserStories, newStory];

            updatedStories[userIndex] = buildStoryGroup({
                userId: newStory.userId,
                stories: mergedStories,
                includeMeta,
            });
        } else {
            // NEW USER
            updatedStories.push(
                buildStoryGroup({
                    userId: newStory.userId,
                    stories: [newStory],
                    includeMeta,
                }),
            );
        }

        // SORT USERS
        updatedStories.sort((a, b) => Number(b?.lastUpdatedAt || 0) - Number(a?.lastUpdatedAt || 0));

        return updatedStories;
    } catch (error) {
        logger.error('groupStoryByUser error:', error);

        // never break redux state
        return existingStories;
    }
};

export const callbacks = {
    channelConnectionListener: function (res) {
        logger.debug('channelConnectionListener ', res);
    },
    channelListener: handleIncomingChannelEvents,
    connectionListener: function (res) {
        const connStatus = res.status || '';
        const prevConnectionState = getConnectionStatus();
        logger.debug('connStatus :>> ', connStatus);
        if (connStatus === 'CONNECTED') {
            encryptAndStoreInLocalStorage('connection_status', connStatus);
            setConnectionStatus(connStatus);
            Store.dispatch(WebChatConnectionState(connStatus));
            if (prevConnectionState !== 'RECONNECTING') {
                login();
            } else {
                serverReconnect();
            }
        } else if (connStatus === 'DISCONNECTED') {
            if (isSameSession() && getFromSessionStorageAndDecrypt('isLogout') === null) {
                reconnect();
            }
            encryptAndStoreInLocalStorage('connection_status', connStatus);
            setConnectionStatus(connStatus);
            Store.dispatch(WebChatConnectionState(connStatus));
        } else if (connStatus === 'CONNECTIONFAILED') {
            encryptAndStoreInLocalStorage('connection_status', connStatus);
            setConnectionStatus(connStatus);
            Store.dispatch(WebChatConnectionState(connStatus));
        } else if (connStatus === 'RECONNECTING') {
            encryptAndStoreInLocalStorage('connection_status', connStatus);
            setConnectionStatus(connStatus);
            Store.dispatch(WebChatConnectionState(connStatus));
        } else if (connStatus === 'AUTHFAIL') {
            logout();
            return;
        }
    },
    incomingCallListener: res => {
        localstoreCommon();
        resetCallData();
        resetLocalCallDataClearAndDiscardUiTimer();
        Store.dispatch(resetCallIntermediateScreen());

        remoteStream = [];
        localStream = null;
        let callMode = 'onetoone';
        if (res.toUsers.length === 1 && res.groupId === null) {
            res.from = res.toUsers[0];
            res.to = res.userJid;
            if (res.callType === 'audio') {
                localVideoMuted = true;
            }
        } else {
            callMode = 'onetomany';
            res.from = res.userJid;
            res.to = res.groupId ? res.groupId : res.userJid;
            res.userList = res.allUsers.join(',');
            if (res.callType === 'audio') {
                localVideoMuted = true;
            }
        }
        res.callMode = callMode;
        encryptAndStoreInLocalStorage('call_connection_status', JSON.stringify(res));
        let roomId = getFromLocalStorageAndDecrypt('roomName');

        if (roomId === '' || roomId === null || roomId === undefined) {
            resetPinAndLargeVideoUser();
            encryptAndStoreInLocalStorage('roomName', res.roomId);
            encryptAndStoreInLocalStorage('callType', res.callType);
            encryptAndStoreInLocalStorage('callFrom', res.from);
            if (res.callType === 'audio') {
                localVideoMuted = true;
            }
            Store.dispatch(CallConnectionState(res));
            Store.dispatch(
                showConfrence({
                    showComponent: false,
                    showStreamingComponent: false,
                    showCalleComponent: true,
                }),
            );
            updatingUserStatusInRemoteStream(res.usersStatus);
            browserNotify.sendCallNotification(res);
            startMissedCallNotificationTimer();
        } else {
            SDK.callEngaged();
        }

        callLogs.insert({
            callMode: res.callMode,
            callState: 0,
            callTime: callLogs.initTime(),
            callType: res.callType,
            fromUser: res.from,
            roomId: res.roomId,
            userList: res.userList,
            groupId: res.callMode === 'onetoone' ? '' : res.groupId,
        });
        setLocalUserOnCall(true);
        startCallingTimer();
        Store.dispatch(fetchingCallLog(true));
        callLogs.getCallLogsFromServer(1);
    },
    callStatusListener: res => {
        callStatus(res);
    },
    userTrackListener: res => {
        if (res.localUser) {
            if (!res.trackType) {
                return;
            }
            localStream = localStream || {};
            let mediaStream = null;
            if (res.track) {
                mediaStream = new MediaStream();
                mediaStream.addTrack(res.track);
            }
            localStream[res.trackType] = mediaStream;
            const { getState, dispatch } = Store;
            const showConfrenceData = getState().showConfrenceData;
            const { data } = showConfrenceData;
            const usersStatus = res.usersStatus;
            usersStatus.map(user => {
                const index = remoteStream.findIndex(item => item.fromJid === user.userJid);
                if (index > -1) {
                    remoteStream[index] = {
                        ...remoteStream[index],
                        status: user.status,
                    };
                    remoteVideoMuted[user.userJid] = user.videoMuted;
                    remoteAudioMuted[user.userJid] = user.audioMuted;
                } else {
                    let streamObject = {
                        id: uuidv4(),
                        fromJid: user.userJid,
                        status: user.status,
                    };
                    remoteStream.push(streamObject);
                    remoteVideoMuted[user.userJid] = user.videoMuted;
                    remoteAudioMuted[user.userJid] = user.audioMuted;
                }
            });
            const roomName = getFromLocalStorageAndDecrypt('roomName');
            if (roomName === '' || roomName == null || roomName == undefined) {
                const { roomId = '' } = SDK.getCallInfo();
                encryptAndStoreInLocalStorage('roomName', roomId);
            }

            dispatch(
                showConfrence({
                    localVideoMuted: localVideoMuted,
                    ...(data || {}),
                    localStream: localStream,
                    remoteStream,
                    localAudioMuted: localAudioMuted,
                    status: 'LOCALSTREAM',
                }),
            );
        } else {
            encryptAndStoreInLocalStorage('callingComponent', false);
            const streamType = res.trackType;
            let mediaStream = null;
            if (res.track) {
                mediaStream = new MediaStream();
                mediaStream.addTrack(res.track);
            }
            const streamUniqueId = `stream${streamType.charAt(0).toUpperCase() + streamType.slice(1)}Id`;
            updatingUserStatusInRemoteStream(res.usersStatus);
            const userIndex = remoteStream.findIndex(item => item.fromJid === res.userJid);
            if (userIndex > -1) {
                let { stream } = remoteStream[userIndex];
                stream = stream || {};
                stream[streamType] = mediaStream;
                stream['id'] = uuidv4();
                stream[streamUniqueId] = uuidv4();
                remoteStream[userIndex]['stream'] = stream;
            } else {
                let streamObject = {
                    id: uuidv4(),
                    fromJid: res.userJid,
                    status: CALL_STATUS_CONNECTED,
                    stream: {
                        [streamUniqueId]: uuidv4(),
                        [streamType]: mediaStream,
                    },
                };
                remoteStream.push(streamObject);
            }

            // When remoteStream user length is one, set that user as large video user
            if (remoteStream.length === 2) {
                Store.dispatch(selectLargeVideoUser(res.userJid));
            } else {
                remoteStream.forEach(item => {
                    return Store.dispatch(selectLargeVideoUser(item.userJid));
                });
            }

            const { showConfrenceData, callConversionData } = Store.getState();
            const { data } = showConfrenceData;
            Store.dispatch(
                showConfrence({
                    showCallingComponent: false,
                    localVideoMuted: localVideoMuted,
                    ...(data || {}),
                    localStream: localStream,
                    remoteStream: remoteStream,
                    fromJid: res.userJid,
                    status: 'REMOTESTREAM',
                    localAudioMuted: localAudioMuted,
                    remoteVideoMuted: remoteVideoMuted,
                    remoteAudioMuted: remoteAudioMuted,
                    callStatusText: CALL_STATUS_CONNECTED,
                }),
            );
            if (!onCall) {
                const { callQualityData } = Store.getState();
                if (callQualityData.data === 'POOR') {
                    Store.dispatch(setPoorConnectionIcon(false));
                    Store.dispatch(setPoorConnectionPopUp(true));
                    setTimeout(() => {
                        Store.dispatch(setPoorConnectionIcon(true));
                        Store.dispatch(setPoorConnectionPopUp(false));
                    }, 5000);
                }
            }
            onCall = true;
            // Need to hide the call converison request & response screen when more than one remote
            // users joined in call
            if (remoteStream.length >= 3) {
                const status =
                    callConversionData && callConversionData.status === CALL_CONVERSION_STATUS_REQ_WAITING
                        ? {
                              status: CALL_CONVERSION_STATUS_CANCEL,
                          }
                        : undefined;
                Store.dispatch(callConversion(status));
                status && SDK.callConversion(CALL_CONVERSION_STATUS_CANCEL);
            }
        }
    },
    muteStatusListener: res => {
        if (!res) return;
        let localUser = false;
        let vcardData = getLocalUserDetails();
        const currentUser = vcardData?.fromUser;
        let mutedUser = res.userJid;
        mutedUser = mutedUser.includes('@') ? mutedUser.split('@')[0] : mutedUser;
        if (res.localUser || currentUser === mutedUser) {
            localUser = true;
        }
        if (localUser) {
            if (res.trackType === CALL_TYPE_AUDIO) {
                localAudioMuted = res.isMuted;
            }
            if (res.trackType === CALL_TYPE_VIDEO) {
                localVideoMuted = res.isMuted;
            }
        } else {
            if (res.trackType === CALL_TYPE_AUDIO) {
                remoteAudioMuted[res.userJid] = res.isMuted;
                if (res.isMuted) {
                    Store.dispatch(selectLargeVideoUser(res.userJid, -100));
                }
            }
            if (res.trackType === CALL_TYPE_VIDEO) {
                remoteVideoMuted[res.userJid] = res.isMuted;
            }
        }

        const showConfrenceData = Store.getState().showConfrenceData;
        const { data } = showConfrenceData;
        let showComponent = data.showComponent;
        let showStreamingComponent = data.showStreamingComponent;
        let showCallingComponent = data.showCallingComponent;
        let showCalleComponent = data.showCalleComponent;

        Store.dispatch(
            showConfrence({
                ...data,
                showComponent: showComponent,
                showStreamingComponent: showStreamingComponent,
                showCallingComponent: showCallingComponent,
                showCalleComponent: showCalleComponent,
                localStream: localStream,
                remoteStream: remoteStream,
                fromJid: res.userJid,
                status: 'MUTESTATUS',
                localVideoMuted: localVideoMuted,
                localAudioMuted: localAudioMuted,
                remoteVideoMuted: remoteVideoMuted,
                remoteAudioMuted: remoteAudioMuted,
            }),
        );
        updateCallTypeAfterCallSwitch();
    },
    missedCallListener: res => {
        callLogs.insert({
            callMode: res.callMode,
            callState: 0,
            callTime: callLogs.initTime(),
            callType: res.callType,
            fromUser: res.from,
            roomId: res.roomId,
            userList: res.allUsers,
            groupId: res.groupId,
        });
    },
    callSwitchListener: res => {
        Store.dispatch(
            callConversion({
                status: res.status,
                fromUser: res.userJid,
            }),
        );
    },
    callSpeakingListener: res => {
        speaking(res);
    },
    callUsersUpdateListener: res => {
        remoteStream.forEach(item => {
            if (!res.usersList.includes(item.fromJid)) {
                removeRemoteStream(item.fromJid);
            }
        });
        Store.dispatch(
            callIntermediateScreen({
                usersList: res.usersList,
            }),
        );
        subscribed(res);
    },
    inviteUsersListener: res => {
        updatingUserStatusInRemoteStream(res.usersStatus);
        const showConfrenceData = Store.getState().showConfrenceData;
        const { data } = showConfrenceData;
        Store.dispatch(
            showConfrence({
                ...(data || {}),
                status: 'REMOTESTREAM',
                remoteStream: remoteStream,
            }),
        );
        callLogs.update(res.roomId, {
            userList: res.userList,
        });
        startCallingTimer();
    },
    mediaErrorListener: res => {
        if (res.action === 'subscribeCall' && res.statusCode === 100607) {
            muteLocalVideo(true);
            const { getState } = Store;
            const showConfrenceData = getState().showConfrenceData;
            const { data } = showConfrenceData;
            Store.dispatch(
                showConfrence({
                    ...(data || {}),
                    mediaError: true,
                    localVideoMuted: true,
                }),
            );
        }
        Store.dispatch(
            showModal({
                open: true,
                modelType: res.callStatus === 'MEDIA_PERMISSION_DENIED' ? 'mediaPermissionDenied' : 'mediaAccessError',
                ...res,
            }),
        );
    },
    messageListener: async function (res) {
        if (res.msgType === LOGOUT || res.msgType === CARBON_LOGOUT) {
            encryptAndStoreInSessionStorage('isLogout', true);
            setTimeout(async () => {
                if (isSameSession()) {
                    await deleteAllIndexedDb();
                    deleteItemFromLocalStorage('username');
                    deleteItemFromLocalStorage('auth_user');
                    deleteItemFromLocalStorage('getuserprofile');
                    deleteItemFromLocalStorage('session_start_time');
                    window.location.reload();
                }
            }, 2000);
            return;
        }

        if (res.msgType === 'simBindLogout') {
            encryptAndStoreInSessionStorage('isLogout', true);
            encryptAndStoreInSessionStorage('is_sim_binding_logout', true);
            setTimeout(async () => {
                if (isSameSession()) {
                    await deleteAllIndexedDb();
                    deleteItemFromLocalStorage('username');
                    deleteItemFromLocalStorage('auth_user');
                    deleteItemFromLocalStorage('getuserprofile');
                    deleteItemFromLocalStorage('session_start_time');
                    window.location.reload();
                }
            }, 2000);
            return;
        }

        if (res.msgType === 'newSession') {
            const newSession = getFromLocalStorageAndDecrypt('newSession');
            if (!newSession || newSession === null) {
                encryptAndStoreInSessionStorage('isLogout', true);
                setTimeout(async () => {
                    if (isSameSession()) {
                        await deleteAllIndexedDb();
                        deleteItemFromLocalStorage('username');
                        deleteItemFromLocalStorage('auth_user');
                        deleteItemFromLocalStorage('getuserprofile');
                        deleteItemFromLocalStorage('session_start_time');
                        window.location.reload();
                    }
                }, 2000);
                return;
            }
        }

        updateLastSyncTime();

        if (res.msgType === 'unreadUpdate') {
            Store.dispatch(UnreadCountDelete({ fromUserId: res.fromUserId }));
        }

        if (res.msgType === 'receiveMessage' && res.chatType === CHAT_TYPE_GROUP && res.msgBody === '2') {
            const groupListRes = await SDK.getGroupsList();
            if (groupListRes && groupListRes.statusCode === 200) {
                let groupsData = groupListRes.data;
                if (Array.isArray(groupsData)) {
                    groupsData = groupsData.map(group => {
                        const currentGroup = getGroupData(group.groupJid);
                        if (group.groupName === group.groupId) {
                            return { ...group, groupName: currentGroup ? currentGroup.groupName : '' };
                        }
                        return group;
                    });
                }
                Store.dispatch(GroupsDataAction(groupsData));
            }
        }

        if (res.msgType === MSG_CLEAR_CHAT || res.msgType === MSG_CLEAR_CHAT_CARBON) {
            const { chatConversationHistory: { data = {} } = {} } = Store.getState();
            messagesIdb.clearMessages(formatUserIdToJid(res.fromUserId, res.chatType));
            const chatMessages = data[res.fromUserId]?.messages || {};
            if (
                chatMessages &&
                (chatMessages[res.lastMsgId] === undefined ||
                    chatMessages[res.lastMsgId] === null ||
                    chatMessages[res.lastMsgId] === '')
            ) {
                Store.dispatch(ClearChatHistoryAction(res));
                Store.dispatch(ClearChatHistoryActionCommon(res));
                Store.dispatch(clearLastMessageinRecentChat(res.fromUserId));
                Store.dispatch(RemoveStaredMessagesClearChat(res));
                return;
            }
            Store.dispatch(ClearChatHistoryActionCommon(res));
            if (Object.keys(chatMessages).length === 0) {
                Store.dispatch(clearLastMessageinRecentChat(res.fromUserId));
            }
            if (res.favourite === '0') {
                Store.dispatch(RemoveStaredMessagesClearChat(res));
            }
        }

        if (res.msgType === MSG_DELETE_CHAT || res.msgType === MSG_DELETE_CHAT_CARBON) {
            const archivedChats = getArchivedChats();
            if (archivedChats.includes(res.fromUserId)) {
                SDK.updateArchiveChat(formatUserIdToJid(res.fromUserId, res.chatType), false);
            }
            recentChatIdb.deleteRecentChat(res.fromUserId);
            // Delete the user from recent chat list
            Store.dispatch(deleteActiveChatAction(res));
            Store.dispatch(DeleteChatHistoryAction(res));
            const chatId = getActiveConversationChatId();
            if (res.fromUserId === chatId) Store.dispatch(ActiveChatResetAction());
            Store.dispatch(RemoveStaredMessagesDeleteChat(res));
        }

        if (res.msgType === 'userBlockStatus' || res.msgType === 'carbonUserBlockStatus') {
            return Store.dispatch(updateContactWhoBlockedMeAction(res.blockedUserId, res.type));
        }
        if (res.msgType === MESSAGE_ERROR) return Store.dispatch(handleMessageError(res));

        if (res.msgType === 'msgDisappear') {
            // Notification banner — shown before async profile refresh so it appears immediately.
            // chatId: for the sender (local user changing from another device), the contact is
            // res.toUserId/res.userId; for a contact changing their setting, it's res.fromUserId.
            const chatId = isLocalUser(res.fromUserId) ? res.toUserId || res.userId : res.fromUserId;
            // If ContactInfo already dispatched a banner for this chat (via markSingleDisappearHandled),
            // skip our own dispatch to avoid a duplicate. Still update vCard data below.
            const alreadyHandledByContactInfo = chatId && pendingDisappearGroupUpdates.has(chatId);
            // Suppress the generic groupProfileUpdated event the SDK fires alongside msgDisappear
            // for single chat — the microtask interceptor will skip it if chatId is marked here.
            if (chatId) {
                pendingDisappearGroupUpdates.add(chatId);
                setTimeout(() => pendingDisappearGroupUpdates.delete(chatId), 5000);
            }
            if (!alreadyHandledByContactInfo && chatId && res.msgDisappear !== undefined) {
                const singleBannerMsg = {
                    msgType: GROUP_CHAT_PROFILE_UPDATED_NOTIFY,
                    msgId: (res.timestamp?.toString() || Date.now().toString()) + '_single_disappear',
                    fromUserId: chatId,
                    fromUserJid: formatUserIdToJid(chatId, CHAT_TYPE_SINGLE),
                    chatType: CHAT_TYPE_SINGLE,
                    publisherId: res.fromUserId,
                    publisherJid: formatUserIdToJid(res.fromUserId),
                    profileUpdatedStatus: GROUP_DISAPPEAR_UPDATED,
                    msgDisappear: res.msgDisappear,
                    msgBody: {},
                    timestamp: res.timestamp || Date.now(),
                    msgStatus: 0,
                };
                Store.dispatch(MessageAction(singleBannerMsg));
                // Direct dispatch bypasses updateRecentChatMessage's hasBodyContent guard
                // so the notification text shows as the recent chat last-message preview.
                Store.dispatch(
                    RecentChatUpdateAction({
                        ...singleBannerMsg,
                        filterBy: chatId,
                    }),
                );
            }

            if (isLocalUser(res.fromUserId)) {
                // Own user changed setting from another device
                const currentData = Store.getState().vCardData?.data || {};
                Store.dispatch({
                    type: VCARD_DATA,
                    payload: { id: uuidv4(), data: { ...currentData, msgDisappear: res.msgDisappear } },
                });
                // Persist so that getUserProfile on next page-load can't silently zero it out.
                // The server profile response does not always carry msgDisappear, causing the
                // setting to be lost whenever VCardDataAction fully replaces vCardData.
                try {
                    localStorage.setItem('_daz_own_msg_disappear', String(res.msgDisappear ?? 0));
                } catch (_) {}
            } else {
                // Contact updated their disappearing messages setting.
                // Step 1: dispatch immediately with correct value so any mounted component reacts.
                const currentData = Store.getState().VCardContactData?.data || {};
                const mergedData =
                    currentData.userId === res.fromUserId
                        ? { ...currentData, msgDisappear: res.msgDisappear }
                        : { userId: res.fromUserId, msgDisappear: res.msgDisappear };
                Store.dispatch({
                    type: VCARD_CONTACT_DATA_ACTION,
                    payload: { id: uuidv4(), data: mergedData },
                });
                // Step 2: re-fetch full profile so VCardContactDataAction fires with complete data.
                // This handles the case where the contact info panel opens later and needs fresh state.
                await SDK.getUserProfile(res.fromUserId);
            }
            return;
        }

        if (res.msgType === GROUP_CHAT_PROFILE_UPDATED_NOTIFY) {
            const groupId = res.fromUserId;
            // Defer to a microtask so groupProfileListener's synchronous top-block always
            // runs before we decide which banner to show, regardless of SDK callback order.
            Promise.resolve().then(() => {
                if (pendingDisappearGroupUpdates.has(groupId)) {
                    pendingDisappearGroupUpdates.delete(groupId);
                    return;
                }
                // 1-1 profile events are timer changes the msgDisappear handler already showed.
                const isGroup = !!getGroupData(formatUserIdToJid(groupId, CHAT_TYPE_GROUP));
                if (isGroup) {
                    // A timer value means a timer event, whatever status the source gave it.
                    const profileUpdatedStatus =
                        res.msgDisappear !== undefined ? GROUP_DISAPPEAR_UPDATED : res.profileUpdatedStatus;
                    Store.dispatch(
                        MessageAction({
                            ...res,
                            msgBody: res.msgBody || {},
                            profileUpdatedStatus,
                            ...(res.msgDisappear !== undefined && { msgDisappear: res.msgDisappear }),
                        }),
                    );
                }
            });
            return;
        }

        if (res.msgType === DELETE_CALL_LOG) {
            Store.dispatch(deleteAllCallLog(res));
        } else {
            // The SDK delivers single-chat profile-update stanzas (e.g. disappear changes) as
            // regular receiveMessage events with msgBody.message_type = 'groupProfileUpdated'.
            if (
                res.msgBody?.message_type === GROUP_CHAT_PROFILE_UPDATED_NOTIFY ||
                res.msgBody === GROUP_CHAT_PROFILE_UPDATED_NOTIFY
            ) {
                // For single-chat: convert to a proper disappear banner using the server's native msgId.
                // This makes the banner persistent across login/logout (server history returns same msgId).
                // Suppress if msgDisappear handler already created a banner for this chat (live event).
                const isSingle = res.chatType === CHAT_TYPE_SINGLE || !isGroupChat(res.chatType);
                const disappearVal = res.msgDisappear ?? res.msgBody?.msgDisappear;
                const chatIdForSuppress = isLocalUser(res.fromUserId) ? res.toUserId || res.fromUserId : res.fromUserId;
                const alreadyHandled = chatIdForSuppress && pendingDisappearGroupUpdates.has(chatIdForSuppress);
                if (isSingle && disappearVal !== undefined && !alreadyHandled) {
                    const bannerFromUserId = isLocalUser(res.fromUserId)
                        ? res.toUserId || res.fromUserId
                        : res.fromUserId;
                    Store.dispatch(
                        MessageAction({
                            ...res,
                            msgType: GROUP_CHAT_PROFILE_UPDATED_NOTIFY,
                            fromUserId: bannerFromUserId,
                            fromUserJid: formatUserIdToJid(bannerFromUserId, CHAT_TYPE_SINGLE),
                            chatType: CHAT_TYPE_SINGLE,
                            profileUpdatedStatus: GROUP_DISAPPEAR_UPDATED,
                            msgDisappear: disappearVal,
                            msgBody: {},
                        }),
                    );
                }
                return;
            }
            Store.dispatch(MessageAction(res));
            // Schedule expiry for disappearing messages (SDK may use disappearAt or disappear_at)
            if (res.disappear_at || res.disappearAt) {
                const isCarbonSent = res.msgType === 'carbonSentMessage';
                const chatId = isCarbonSent ? getUserIdFromJid(res.toJid || res.toUserJid || '') : res.fromUserId;
                if (chatId) scheduleMessageExpiry(res, chatId);
            }
        }
        if (res.nickName && isGroupChat(res.chatType)) {
            const normalizedNickName = normalizeXmlText(res.nickName);

            const groupJid = formatUserIdToJid(res.fromUserId, CHAT_TYPE_GROUP);
            const currentGroup = getGroupData(groupJid);

            if (
                normalizedNickName !== res.groupId &&
                (!currentGroup || currentGroup.groupName !== normalizedNickName)
            ) {
                const obj = {
                    groupJid,
                    groupProfile: {
                        nickName: normalizedNickName,
                    },
                };
                Store.dispatch(GroupDataUpdateAction(obj));
            }
        }
    },
    editMessageListener: async function (res) {
        // Handled Edited message callbacks here
        const { msgType } = res;
        if (msgType === 'carbonSentMessage' || msgType === 'receiveMessage' || msgType === 'carbonReceiveMessage') {
            Store.dispatch(MessageAction(res));
        }
    },
    groupProfileListener: async function (res) {
        // Mark BEFORE any await so messageListener (which may run while we're suspended)
        // can suppress the generic "changed group profile" banner for disappear-only updates.
        if (res?.groupJid && isGroupDisappearNotice(res)) {
            const groupId = res.groupId || getUserIdFromJid(res.groupJid);
            pendingDisappearGroupUpdates.add(groupId);
            setTimeout(() => pendingDisappearGroupUpdates.delete(groupId), 5000);
        }
        if (res?.groupJid) {
            const groupData = getGroupData(res.groupJid);
            const groupPartRes = await SDK.getGroupParticipants(res.groupJid);
            if (groupPartRes && groupPartRes.statusCode === 200) {
                setGroupParticipantsByGroupId(res.groupJid, groupPartRes.data.participants);
            }
            handleTempArchivedChats(res.groupJid, CHAT_TYPE_GROUP);

            // Send notification when current user is added to a group
            if (res.msgType === GROUP_USER_ADDED && res.newUserId === getLocalUserId()) {
                const publisherId = res?.publisherJid ? getUserIdFromJid(res.publisherJid) : null;
                const isPublisherCurrentUser = publisherId && isLocalUser(publisherId);

                // Check not current publisher user's action for himself
                if (!isPublisherCurrentUser) {
                    const groupName = res?.groupName || groupData?.groupName;
                    const titleName = groupName ? `the group "${groupName}"` : 'a new Group';
                    const publisherName =
                        getUserDetails(res?.publisherJid)?.displayName || res?.publisherProfile?.nickName || 'Someone';
                    const notificationTitle = `You were added to ${titleName} by ${publisherName}`;
                    const groupImage = groupData?.groupImage || groupData?.thumbImage || '';
                    const groupId = res.groupId || getUserIdFromJid(res.groupJid);

                    sendNotification(groupName || 'New Group', groupImage, notificationTitle, groupId);
                }
            }
            if (
                groupData &&
                res.msgType === GROUP_USER_ADDED &&
                res.newUserId === getLocalUserId() &&
                groupData.historyEnabled === 1
            ) {
                const chatMessageRes = await SDK.getChatMessages({ toJid: res.groupJid });
                if (chatMessageRes.statusCode === 200) {
                    let updatedChatMessages = chatMessageRes;
                    updatedChatMessages.data.historyEnabledUser = 1;
                    Store.dispatch(ChatMessageHistoryDataAction(updatedChatMessages));
                }
            }
            if (groupData && isActiveConversationUserOrGroup(res.groupJid)) {
                // Fetch the group participants details
                if (
                    [
                        GROUP_USER_ADDED,
                        GROUP_USER_REMOVED,
                        GROUP_USER_MADE_ADMIN,
                        GROUP_PROFILE_INFO_UPDATED,
                        GROUP_USER_LEFT,
                    ].indexOf(res.msgType) > -1
                ) {
                    if (groupPartRes && groupPartRes.statusCode === 200) {
                        setGroupParticipants(groupPartRes.data);
                    }
                }
            } else if (res.msgType === GROUP_USER_ADDED) {
                const groupListRes = await SDK.getGroupsList();
                if (groupListRes && groupListRes.statusCode === 200) {
                    let groupsData = groupListRes.data;
                    if (Array.isArray(groupsData)) {
                        groupsData = groupsData.map(group => {
                            const currentGroup = getGroupData(group.groupJid);
                            if (group.groupName === group.groupId) {
                                return { ...group, groupName: currentGroup ? currentGroup.groupName : '' };
                            }
                            return group;
                        });
                    }
                    Store.dispatch(GroupsDataAction(groupsData));
                }
                const recentChatsRes = await SDK.getRecentChatsByPagination();

                if (recentChatsRes && recentChatsRes.statusCode === 200) {
                    Store.dispatch(RecentChatAction(recentChatsRes.data));
                }
            }
            if (isGroupDisappearNotice(res)) {
                const groupId = res.groupId || getUserIdFromJid(res.groupJid);
                const publisherUserId = res.publisherId
                    ? getUserIdFromJid(res.publisherId)
                    : getUserIdFromJid(res.publisherJid);
                const groupBannerMsg = {
                    msgType: GROUP_CHAT_PROFILE_UPDATED_NOTIFY,
                    msgId: (res.timestamp?.toString() || Date.now().toString()) + '_disappear',
                    fromUserId: groupId,
                    fromUserJid: res.groupJid,
                    chatType: CHAT_TYPE_GROUP,
                    publisherId: publisherUserId,
                    publisherJid: res.publisherJid || res.publisherId,
                    profileUpdatedStatus: GROUP_DISAPPEAR_UPDATED,
                    msgDisappear: res.groupProfile.msgDisappear,
                    msgBody: {},
                    timestamp: res.timestamp || Date.now(),
                    msgStatus: 0,
                };
                Store.dispatch(MessageAction(groupBannerMsg));
                Store.dispatch(
                    RecentChatUpdateAction({
                        ...groupBannerMsg,
                        filterBy: groupId,
                    }),
                );
            }
            Store.dispatch(GroupDataUpdateAction(res));

            // The open conversation reads its title from activeChatData, which is a
            // snapshot taken when the chat was opened — groupsData alone repaints the
            // recent-chat row but leaves the header and group info stale until reload.
            const updatedGroupName = res.groupName || res.groupProfile?.nickName;
            if (updatedGroupName && isActiveConversationUserOrGroup(res.groupJid)) {
                Store.dispatch(updateGroupName({ groups: [{ nickName: updatedGroupName }] }));
            }
        }
        handleGroupProfileUpdate(res);
    },
    groupMemberListListener: function (res, communicationType) {
        // We are maintaing the separate group members list reducer for chat & call
        // Because If currently user in group chat screen, at the same time if user gets the group call
        // & attended the group call, then try to invite the new user from group, then need to show the
        // Group member list in invite user popup. So in this situation, Current chat screen & call group is
        // different, to avoid the group override maintain the separate groups for call & chat.
        if (communicationType !== 'call') {
            Store.dispatch(GroupsMemberListAction(res));
        }
        Store.dispatch(currentCallGroupMembers(res));
    },
    presenceListener: function (res) {
        Store.dispatch(PresenceDataAction(res));
    },
    setUserToken: function (token) {
        if (!token) {
            deleteItemFromLocalStorage('token');
            return;
        }
        encryptAndStoreInLocalStorage('token', token);
    },
    // New Callback Listeners from New SDK
    friendsListListener: function (res) {
        Store.dispatch(RosterPermissionAction(res.permission));
        Store.dispatch(RosterDataAction(res.users));
    },
    userProfileListener: async function (res) {
        if (res.fromUserId && res.msgType === 'seen_receipt') {
            const update = {};
            update.seenReceipt = Number(res.privacySettings);
            Store.dispatch(PrivacySettingsAction(update));
            return;
        }
        if (res.msgType === 'hide_profile') {
            const hideVal = Number(res.privacySettings);
            if (res.fromUserId && isLocalUser(res.fromUserId)) {
                // Keep payload shape simple (top-level key). Other places read either
                // privacySettings.hideProfile or privacySettingsData.hideProfile so
                // reducers/components will pick this up.
                Store.dispatch(PrivacySettingsAction({ hideProfile: hideVal }));
                return;
            }

            // Otherwise it's for another user — refresh that user's profile in store
            // so the contact's visibility/image gets updated.
            if (res.fromUserId && !isLocalUser(res.fromUserId)) {
                const targetUserId = res.fromUserId;
                await SDK.getUserProfile(targetUserId);
                return;
            }
        }

        if (res.msgType === 'msgDisappear') {
            const targetUserId = res.fromUserId || res.userId;
            if (targetUserId) {
                await SDK.getUserProfile(targetUserId);
            }
            return;
        }
        Store.dispatch(setUserInfoArr([res]));
        let authUser = getFromLocalStorageAndDecrypt('auth_user');
        if (authUser.username === res.userId) {
            // The server profile may not return msgDisappear (it may strip the field).
            // VCardDataAction does a full-replace, so we restore the persisted value
            // from localStorage (set by settings UI / msgDisappear callback) or from
            // idb (set by idbSyncMiddleware) to prevent the setting being zeroed on
            // every page load or reconnect.
            let profileData = res;
            if (res.msgDisappear === undefined || res.msgDisappear === null) {
                // 1. localStorage — fastest, synchronous
                let restored;
                try {
                    const stored = localStorage.getItem('_daz_own_msg_disappear');
                    if (stored !== null) restored = Number(stored);
                } catch (_) {}
                // 2. idb (localforage) — reliable even if localStorage was cleared
                if (!restored) {
                    try {
                        const IndexedDbMod = (await import('../Helpers/IndexedDb')).default;
                        const idbInst = new IndexedDbMod();
                        const meta = await idbInst.getMetadata('own_msgDisappear');
                        if (meta?.value !== undefined) restored = Number(meta.value);
                    } catch (_) {}
                }
                if (restored) {
                    profileData = { ...res, msgDisappear: restored };
                    // Keep localStorage in sync for next time
                    try {
                        localStorage.setItem('_daz_own_msg_disappear', String(restored));
                    } catch (_) {}
                }
            } else {
                // Server did return the value — persist it for future restores
                try {
                    localStorage.setItem('_daz_own_msg_disappear', String(res.msgDisappear));
                } catch (_) {}
            }
            Store.dispatch(VCardDataAction(profileData));
        } else {
            const VCardProfileData = {
                ...res,
                ...(!REACT_APP_CONTACT_SYNC ? { name: res.nickName } : {}),
                isDeletedUser: false,
                displayName: res.nickName,
            };
            Store.dispatch(VCardContactDataAction(VCardProfileData));
        }
    },
    favouriteMessageListener: function (res) {
        // A clear-all carries no message id, so it empties the list.
        if (res?.clearAll) {
            const starred = Store.getState().starredMessages?.data || [];
            Store.dispatch(RemoveAllStarredMessages());
            Store.dispatch(RemoveAllStarredMessagesHistory(starred));
            return;
        }
        Store.dispatch(UpdateFavouriteStatus(res));
        Store.dispatch(UpdateStarredMessages(res));
    },
    // Fires for pins other participants made, not only the user's own devices.
    pinMessageListener: function (res) {
        Store.dispatch(fetchPinnedMessages(res?.fromUserJid));
    },
    keepMessageListener: res => Store.dispatch(receiveKeepPush(res)),
    pollEventListener: res => Store.dispatch(applyPollEvent(res)),
    pollActivitiesListener: res => Store.dispatch(receivePollActivities(res)),
    liveLocationEventListener: res => Store.dispatch(receiveLiveLocationEvent(res)),
    groupMsgInfoListener: function (res) {
        Store.dispatch(messageInfoAction(res));
    },
    mediaUploadListener: function (res) {
        Store.dispatch(MediaUploadDataAction(res));
    },
    mediaDownloadListener: function (res) {
        if (res?.msgId != null) {
            Store.dispatch(MediaDownloadDataAction(res));
        }
    },
    /**
     * This listener will be called, when a same user logged in another device
     * and block any user from that device, then this listener will receive the
     * list blocked user details res as same as 'SDK.getUsersIBlocked()'
     */
    blockUserListener: function (res) {
        Store.dispatch(updateBlockedContactAction(res.blockedUserId, res.type));
    },
    singleMessageDataListener: function (res) {
        Store.dispatch(updateMsgByLastMsgId(res));
    },
    muteChatListener: function (res) {
        if (res.muteSetting) {
            updateMuteSettings(res.isMuted);
        } else {
            updateMuteStatus(res);
            if (res.isMuted) syncMutedChats();
        }
    },
    archiveChatListener: function (res) {
        Store.dispatch(updateArchiveStatusRecentChat(res));
    },
    userSettingsListener: function (res) {
        setLocalWebsettings('archive', res.archive === 1);
        Store.dispatch(
            webSettingLocalAction({
                isEnableArchived: res.archive === 1,
            }),
        );
    },
    helper: {
        getDisplayName: _metadata => {
            let vcardData = getLocalUserDetails();
            if (vcardData && vcardData.nickName) {
                return vcardData.nickName;
            }
            return 'Anonymous user ';
        },
        getImageUrl: () => {
            let vcardData = getLocalUserDetails();
            if (vcardData) {
                return vcardData.image;
            }
            return '';
        },
    },
    callUserJoinedListener: function (res) {
        if (res.userJid && !res.localUser) {
            updateStoreRemoteStream();
            handleCallParticipantToast(res.userJid, 'join');
        }
    },
    callUserLeftListener: function (res) {
        if (res.userJid && !res.localUser) {
            updateStoreRemoteStream();
            handleCallParticipantToast(res.userJid, 'left');
        }
    },
    adminBlockListener: function (res) {
        let callConnectionGroupJid = null;
        if (onCall) {
            callConnectionGroupJid = Store.getState()?.callConnectionDate?.data?.groupId;
        }
        if (isLocalUser(res.toUserId)) {
            if (res.blockStatus === '1') {
                Store.dispatch(adminBlockStatusUpdate(res));
                SDK.endCall();
                resetCallData();
                stopRecorder();
                logout('block');
            }
        } else if (isSingleChatJID(res.toUserJid)) {
            if (isActiveConversationUserOrGroup(res.toUserId) && res.blockStatus === '1') {
                stopRecorder();
            }
            Store.dispatch(
                VCardContactDataAction({
                    userId: res.toUserId,
                    isAdminBlocked: res.blockStatus === '1',
                }),
            );
        } else {
            if (isActiveConversationUserOrGroup(res.toUserId)) {
                if (res.blockStatus === '1') {
                    Store.dispatch(messageForwardReset());
                    Store.dispatch(ActiveChatResetAction());
                    stopRecorder();
                    toast.info('This group is no longer available');
                    Store.dispatch(hideModal());
                    if (callConnectionGroupJid === res.toUserJid) {
                        disconnectCallConnection();
                    }
                }
            } else if (callConnectionGroupJid === res.toUserJid && res.blockStatus === '1') {
                disconnectCallConnection();
            }
            Store.dispatch(
                GroupDataUpdateAction({
                    groupJid: res.toUserJid,
                    isAdminBlocked: res.blockStatus === '1',
                }),
            );
        }
    },
    userDeletedListener: async userJid => {
        let data = await getDataFromRoster(getUserIdFromJid(userJid));
        Store.dispatch(deletedUserInfo({ userId: getUserIdFromJid(userJid) }));
        Store.dispatch(
            VCardContactDataAction({
                ...data,
                isDeletedUser: true,
                email: '',
                image: '',
                isFriend: false,
                mobileNumber: '',
                name: 'Deleted User',
                nickName: 'Deleted User',
                displayName: 'Deleted User',
                status: '',
            }),
        );
    },
    callConnectionQualityListener: data => {
        Store.dispatch(setCallQuality(data.quality));
        if (data.quality === 'POOR') {
            Store.dispatch(setPoorConnectionPopUp(true));
            setTimeout(() => {
                Store.dispatch(setPoorConnectionIcon(true));
                Store.dispatch(setPoorConnectionPopUp(false));
            }, 5000);
        }
        if (data.quality === 'AVERAGE' || data.quality === 'GOOD') {
            Store.dispatch(setPoorConnectionIcon(false));
            Store.dispatch(setPoorConnectionPopUp(false));
        }
    },
    storyListener: res => {
        const { msgType = '', data = {} } = res;
        const storiesState = Store.getState().stories;

        if (msgType === STORY_POSTED) {
            const updatedMyStories = groupStoryByUser(storiesState.myStories, data, false);

            Store.dispatch(setMyStories(updatedMyStories));
        } else if (msgType === STORY_RECEIVED) {
            if (data?.status === 'deleted') {
                Store.dispatch(removeStoryById({ storyId: data.storyId, target: 'stories' }));
            } else {
                const updatedStories = groupStoryByUser(storiesState.stories, data, true);
                Store.dispatch(setStories(updatedStories));
            }
        } else if (msgType === STORY_VIEWER_INFO) {
            // IQ delivers a single viewer at a time: { storyId, viewer (username string), userId }
            // Use current time as viewedAt since IQ doesn't carry a timestamp.
            Store.dispatch(
                mergeStoryViewers({
                    userId: data?.userId,
                    storyId: data?.storyId,
                    viewers: [{ viewerUsername: data?.viewer, viewedAt: new Date().toISOString() }],
                }),
            );
        } else if (msgType === STORY_LIKE) {
            Store.dispatch(
                updateStoryViewerLike({
                    storyId: data.storyId,
                    likedBy: data.likedBy,
                    liked: data.liked,
                }),
            );
        }
    },
};

let localCallDataClearAndDiscardUiTimer = null;

export const localCallDataClearAndDiscardUi = () => {
    localCallDataClearAndDiscardUiTimer = setTimeout(() => {
        localstoreCommon();
        dispatchCommon();
    }, DISCONNECTED_SCREEN_DURATION);
};

export const resetLocalCallDataClearAndDiscardUiTimer = () => clearTimeout(localCallDataClearAndDiscardUiTimer);

export const setLocalUserOnCall = data => {
    localUserOnCall = data;
};

export const isLocalUserOnCall = () => localUserOnCall;
